export const CASINO_GAMES_QUERY = `
  query CasinoGames($page: Int!, $pageSize: Int!, $filter: CasinoGamesFilter) {
    casinoGames(page: $page, pageSize: $pageSize, filter: $filter) {
      total
      page
      pageSize
      items {
        id
        slug
        externalId
        title
        description
        image
        alternativeImageFile { id url filename website type }
        providerId
        categoryIds
        mobileClient
        desktopClient
        demoWorking
        status
        mainProvider
        position
        rtp
        volatility
        isBonusBuy
        isMegaways
        tags {
          id
          slug
          title
        }
      }
    }
  }
`;

export const PROVIDERS_QUERY = `
  query Providers($slotegratorOnly: Boolean!) {
    casinoProviders(slotegratorOnly: $slotegratorOnly) {
      id
      title
      slug
      position
      imageUrl
      iconUrl
    }
  }
`;

export const CATEGORIES_QUERY = `
  query Categories {
    casinoCategories {
      id
      title
      slug
      position
      imageUrl
      iconUrl
    }
  }
`;

export const LAUNCH_MUTATION = `
  mutation Launch($input: LaunchCasinoGameInput!) {
    launchCasinoGame(input: $input) {
      url
      sessionToken
      game { id slug title }
    }
  }
`;

export const CREATE_DEPOSIT_SESSION_MUTATION = `
  mutation CreateDepositSession($input: CreateDepositSessionInput) {
    createDepositSession(input: $input) {
      cashierSessionId
      cashierUrl
      html
      expiresAt
      ttlSeconds
    }
  }
`;
